<template>

    <div class="d-flex">

        <NavBarLeft path="/calculadora"></NavBarLeft>

        <div class="flex-1">

            <HeaderPage title="Contratação GRPRO" subtitle="Simule uma contratação da aplicação"></HeaderPage>


            <div class="d-flex gap-2">

                <div class="flex-1">

                    <div class="my-2 ms-2 p-2 bg-white ">

                        <div class="flex-1 mb-2">
                            <SelectField classLabel="form-label" label="Selecione o Plano *" labelOption="nome"
                                :options="getPlanos()" placeHolder="Escolha um Plano" valueProp="id" :canClear="true"
                                v-model="calculadora.planoId" @update:modelValue="updatePlanoSelecionado"
                                :required="true" />
                        </div>

                        <div class="flex-1 mb-2">
                            <InputField :required="true" label="Número de licenças *" type="number"
                                placeHolder="Digite aqui o número de usuários *" v-model="calculadora.numero_usuarios"
                                min="1" step="1" />
                        </div>

                        <div v-show="selecionarParceria" class="flex-1">
                            <SelectField classLabel="form-label" label="Selecione a Parceria" labelOption="nome"
                                :options="parceriasStore.parcerias" placeHolder="Escolha uma parceria" valueProp="id"
                                :canClear="true" v-model="calculadora.parceriaId" :required="true"
                                @update:modelValue="updateParceriaSelecionado" />
                        </div>

                    </div>

                    <div class="m-2 p-2 bg-white" v-if="planoSelecionado?.id">

                        <template v-if="!modulosExtras.length">

                            <div class="d-flex flex-column gap-1 text-center mb-1">
                                <i class="ri-rocket-line" style="font-size:50px;color: #999;"></i>
                                <h4 class="mb-0">Turbine sua Gestão</h4>
                                <span style="color: #999;">Adicione módulos de acordo com sua necessidade</span>

                                <div class="d-flex justify-content-center">
                                    <DropdownFloating v-model:shown="dropdownShownAddModulo" :distance="6"
                                        placement="left-start">

                                        <ButtonField icon="ri-add-line" type="success" size="small"
                                            text="Adicionar Complemento"></ButtonField>


                                        <template #popper>
                                            <div class="p-3 d-flex gap-2 flex-column" style="width: 300px">

                                                <SelectField classLabel="form-label" label="Selecione o Módulo *" labelOption="nome"
                                                :options="getModulosTable()" placeHolder="Escolha um Módulo" valueProp="id" :canClear="true"
                                                v-model="moduloExtraAdd" @update:modelValue="addModuloExtra()"
                                                :required="true" />

                                            </div>
                                        </template>

                                    </DropdownFloating>
                                </div>

                            </div>

                        </template>

                        <template v-else>

                            <div class="mb-2 d-flex justify-content-end">
                                <div>

                                    <DropdownFloating v-model:shown="dropdownShownAddModulo" :distance="6"
                                    placement="bottom-start">

                                        <ButtonField icon="ri-add-line" type="success" size="small"
                                            text="Adicionar Complemento"></ButtonField>


                                        <template #popper>
                                            <div class="p-3 d-flex gap-2 flex-column" style="width: 300px">

                                                <SelectField classLabel="form-label" label="Selecione o Módulo *" labelOption="nome"
                                                :options="getModulosTable()" placeHolder="Escolha um Módulo" valueProp="id" :canClear="true"
                                                v-model="moduloExtraAdd" @update:modelValue="addModuloExtra()"
                                                :required="true" />

                                            </div>
                                        </template>

                                    </DropdownFloating>

                                </div>
                                
                            </div>
                            
                            <div class="d-flex flex-column gap-1">
                                
                                <div class="p-2 border rounded-3 d-flex justify-content-between align-items-center" v-for="modulo in getModulosTableSelecionados()" :key="modulo">

                                    <span>
                                        {{ modulo.nome }}
                                        <small class="text-info">(Adicional de {{ $moneyConvert.convert(modulo.valor) }}
                                            por usuário
                                            extra)</small>
                                    </span>

                                    <div>
                                        <ButtonField @click="modulosExtras = modulosExtras.filter(m => m != modulo.id)" icon="ri-delete-bin-line" type="danger" size="small" text="Remover"></ButtonField>
                                    </div>

                                </div>

                            </div>

                        </template>

                    </div>


                </div>

                <div v-if="planoSelecionado?.id" class="my-2 me-2 p-2 bg-white">

                    <h4>Resumo da contratação</h4>

                    <div class="d-flex justify-content-between gap-3" v-if="planoSelecionado?.id">
                        <span>{{ planoSelecionado.nome }}</span>
                        <span>{{ $moneyConvert.convert(planoSelecionado.valor) }}</span>
                    </div>

                    <div class="d-flex justify-content-between gap-3" v-for="modulo in planoSelecionado.modulos" :key="modulo">

                        <span>{{ modulo.nome }}</span>
                        <template v-if="this.calculadora.numero_usuarios > 1">
                            {{ $moneyConvert.convert(modulo.valor * (this.calculadora.numero_usuarios - 1))}}
                        </template>
                        <template v-else>
                            -
                        </template>

                    </div>

                    <hr>

                    <h5 style="font-size: 16px;">Licenças</h5>
                    <div class="d-flex justify-content-between gap-3">
                        <span>{{  this.calculadora.numero_usuarios }}x Usuário(s)</span>
                        <span>-</span>
                    </div>

                    <template v-if="modulosExtras.length">

                        <hr >
                        <h5 style="font-size: 16px;">Complementos</h5>
                        <div class="d-flex justify-content-between gap-3" v-for="modulo in getModulosTableSelecionados()" :key="modulo">

                            <span>{{ modulo.nome }}</span>

                            {{ $moneyConvert.convert(modulo.valor *
                                    this.calculadora.numero_usuarios)}}
                            

                        </div>

                    </template>
                        

                    <hr>

                    <div class="d-flex justify-content-between gap-3">
                        <span>Sub Total</span>
                        <span>{{ $moneyConvert.convert(getValorSubTotal()) }}</span>
                    </div>

                    <div v-if="calculadora.parceriaId" class="d-flex justify-content-between gap-3">
                        <span>{{ parceriaSelecionada.percentual_desconto }}% de desconto da Parceria</span>
                        <span>-{{ $moneyConvert.convert(getValorDescontoParceria()) }}</span>
                    </div>

                    <div class="d-flex justify-content-between gap-3">
                        <span>Total</span>
                        <span>{{ $moneyConvert.convert(getValorTotal())
                                            }}</span>
                    </div>

                    <div class="mt-3">
                        <ButtonField :widthMax="true" @click="contratar()" icon="ri-rocket-line" type="success" size="large" text="Contratar"></ButtonField>
                    </div>


                </div>

            </div>



        </div>

    </div>
</template>


<script>
import { useAuthStore } from '@/stores/auth.js';
import { useModulosStore } from '@/stores/modulos';
import { useParceriasStore } from '@/stores/parcerias';
import { usePlanosStore } from '@/stores/planos';

export default {
    name: 'CalculadoraComercialPage',
    data() {
        return {

            moduloExtraAdd: '',
            dropdownShownAddModulo: false,
            authStore: useAuthStore(),
            parceriasStore: useParceriasStore(),
            modulosStore: useModulosStore(),
            planosStore: usePlanosStore(),
            selecionarParceria: false,

            calculadora: {

                planoId: '',
                numero_usuarios: 1,
                parceriaId: ''

            },
            planoSelecionado: [],
            parceriaSelecionada: [],
            modulosExtras: []

        }
    },
    components: {},
    methods: {

        contratar(){
            const objStoreContratacao = {
                planoId: this.planoSelecionado.id,
                modulosExtras: this.modulosExtras,
                numero_usuarios: this.calculadora.numero_usuarios
            }
            localStorage.setItem('cacheContratacao', JSON.stringify(objStoreContratacao))
            this.$router.push('/app?modalContratar=true')
        },

        addModuloExtra(){
            if(this.moduloExtraAdd){
                this.modulosExtras.push(this.moduloExtraAdd)
                this.moduloExtraAdd = ''
            }
        },
        getModulosTable() {
            if (!this.planoSelecionado.id) return this.modulosStore.modulos
            return this.modulosStore.modulos.filter(m => !this.planoSelecionado.modulos.find(m2 => m2.id == m.id))
        },
        getModulosTableSelecionados() {
            if (!this.planoSelecionado.id) return []
            const modulos = this.modulosStore.modulos.filter(m => this.modulosExtras.find(m2 => m2 == m.id))
            return modulos
        },
        updateModuloExtra(modulo) {
            if (this.modulosExtras.includes(modulo.id)) {
                this.modulosExtras = this.modulosExtras.filter(m => m != modulo.id)
            } else {
                this.modulosExtras.push(modulo.id)
            }
        },
        getValorSubTotal() {
            let valor = 0
            if (this.planoSelecionado.id) {

                valor += this.planoSelecionado.valor

                if (this.calculadora.numero_usuarios > 1) {
                    for (const modulo of this.planoSelecionado.modulos) {
                        valor += modulo.valor * (this.calculadora.numero_usuarios - 1)
                    }
                }

            }

            for (const moduloId of this.modulosExtras) {
                const modulo = this.modulosStore.modulos.find(m => m.id == moduloId)
                valor += (modulo.valor * this.calculadora.numero_usuarios)
            }

            return valor
        },
        getValorDescontoParceria() {
            if (!this.parceriaSelecionada.id) return 0

            let valor = (this.parceriaSelecionada.percentual_desconto * this.getValorSubTotal()) / 100
            return valor

        },
        getValorTotal() {
            let valor = this.getValorSubTotal()
            return valor - this.getValorDescontoParceria()
        },

        getPlanos() {
            const planos = []
            for (const plano of this.planosStore.planos) {
                planos.push({
                    id: plano.id,
                    nome: `${plano.nome} | ${this.$moneyConvert.convert(plano.valor)}`
                })
            }
            return planos
        },
        async updatePlanoSelecionado() {

            if (!this.calculadora.planoId) {
                this.modulosExtras = []
                this.planoSelecionado = []
                return
            }

            const planoSelecionado = await this.planosStore.getOne(this.calculadora.planoId)
            this.planoSelecionado = planoSelecionado.plano
            this.modulosExtras = []
        },
        async updateParceriaSelecionado() {

            if (!this.calculadora.parceriaId) {
                this.parceriaSelecionada = {}
                return
            }

            this.parceriaSelecionada = this.parceriasStore.parcerias.find(p => p.id == this.calculadora.parceriaId)

        },

    },
    mounted() {
        this.parceriasStore.get()
        this.modulosStore.get()
        this.planosStore.get()

        if(this.authStore.usuario?.parceriaId)
        {
            this.calculadora.parceriaId = this.authStore.usuario.parceriaId
        }
        else{
            this.selecionarParceria = true
        } 
    }
}
</script>